import * as React from 'react';

import IconProps from 'packages/kakapo-ui-kit/assets/icons/IconProps';

function CalendarIcon(props: IconProps) {
	const { color } = props;

	return (
		<svg width={17} height={18} viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.75 18.001H1.126A1.125 1.125 0 010 16.876V2.251c0-.622.504-1.126 1.125-1.126H4.5V0h1.125v1.125h5.625V0h1.125v1.125h3.938c.621 0 .563.504.563 1.125v14.626c0 .622-.504 1.125-1.125 1.125zm0-15.188a.563.563 0 00-.562-.563h-2.813v1.126H11.25V2.25H5.625v1.126H4.5V2.25H1.688a.563.563 0 00-.563.563v1.688H15.75V2.813zm0 2.813H1.126v10.687c0 .311.252.563.563.563h13.5c.31 0 .563-.252.563-.563V5.626zm-4.5 6.75h3.376v3.375H11.25v-3.376zm1.125 2.25h1.126v-1.125h-1.126v1.125zm-1.124-6.75h3.375v3.374H11.25V7.876zm1.124 2.25h1.126V9h-1.126v1.125zm-5.624 2.25h3.375v3.375H6.75v-3.376zm1.125 2.25H9v-1.125H7.876v1.125zM6.75 7.876h3.375v3.374H6.75V7.876zm1.125 2.25H9V9H7.876v1.125zm-5.626 2.25h3.376v3.375H2.25v-3.376zm1.125 2.25H4.5v-1.125H3.375v1.125zM2.25 7.876h3.376v3.374H2.25V7.876zm1.125 2.25H4.5V9H3.375v1.125z"
				fill={color ?? '#6C7680'}
				fillRule="nonzero"
			/>
		</svg>
	);
}

export default CalendarIcon;
